import * as React from 'react';
import * as ReactDOM from 'react-dom';
import App from './App';
import './index.css';
import registerServiceWorker from './registerServiceWorker';
import { HashRouter } from 'react-router-dom';
import { ContactModel } from './models/contact-models';
import { loadRepositoryURLs } from './server/graphDB-utils';
import StorageUtils from './server/utils/storage-utils';
require("./prototype");

const HashRouter2:any = HashRouter;

interface AppState {
  authenticatedUser: ContactModel;
}

export interface ContextInterface {
  logout: () => void;
  authenticatedUser: ContactModel;
}

export const AppContext = React.createContext<ContextInterface>(Object());

export class AppComponent extends React.Component<any, AppState> {
  constructor(props: any) {
    super(props);
    this.state = {
      authenticatedUser: Object()
    }
    this.logout = this.logout.bind(this);
  }

  async componentDidMount() {
    let authenticatedUser = this.state.authenticatedUser;
    let user: ContactModel = JSON.parse(StorageUtils.getItem('user'));
    if (user && (!authenticatedUser || authenticatedUser.name != user.name)) {
      authenticatedUser.contact = user.contact;
      authenticatedUser.name = user.name;
      authenticatedUser.group = user.group;
      authenticatedUser.mobile = user.mobile;
      authenticatedUser.email = user.email;
      authenticatedUser.role = user.role;
      this.setState({
        authenticatedUser,
      });

    }
    else {
    }
  }
  logout() {
    StorageUtils.clear();
    this.setState({ authenticatedUser: Object() });
    //window.location.reload();

  }

  render() {
    return (
      <AppContext.Provider value={{
        logout: this.logout,
        authenticatedUser: this.state.authenticatedUser
      }} >
        <HashRouter2 hashType={'noslash'}>
          <App />
        </HashRouter2>
      </AppContext.Provider>
    )
  }
}

$(document).ready(function () {
  loadRepositoryURLs();
  setInterval(() => { loadRepositoryURLs() }, 15 * 60 * 1000);
  ReactDOM.render(
    location.href.toLocaleLowerCase().indexOf("invalidinstance") != -1 ? <h3>Instance is not available.</h3> :
      // location.href.toLocaleLowerCase().indexOf("#") == -1 ?
      //   <div className="col-md-12" style={{ textAlign: "center" }}><br /><h2>URL is not correct. Please type a valid URL.</h2></div> : 
        <AppComponent></AppComponent>
    ,
    document.getElementById('root') as HTMLElement
  );
  registerServiceWorker();

  setTimeout(() => {
    $('input').on('input', function () {
      // $(this).val($(this).val().toString().replace(/[^a-z0-9]/gi, '')); //comment this
      var inputBox = $(this);
      setTimeout(() => {
        if (inputBox[0] && inputBox[0]["type"] == "text")
          inputBox.val(inputBox.val().toString().replace(/"/g, '').replace(/'/g, '').replace(/`/g, ''));
      }, 100);
    });

  }, 1000);
});




// WEBPACK FOOTER //
// ./src/index.tsx